module.exports = __webpack_public_path__ + "img/our-product.eaca8c1a.webp";